<template>
    <div :id="id" class="single type-names">
        <p :class="classes.primary" v-for="(name, n) in names" :key="n">{{ name }}</p>
    </div>
</template>

<script>
import $ from "jquery";
import { Animation } from "@/assets/JS/Animation.js";
import { CONFIG } from "@/assets/JS/Config.js";
import { projectModel } from "@/models";

export default {
    name: "ProjectDetailTypesSectionType",
    props: {
        id: String,
        names: Array,
        primary: Boolean,
        contentInitiated: Boolean
    },
    data: () => ({ classes: { primary: "" } }),
    beforeMount: function() {
        this.classes.primary = this.primary ? "type-primary" : "";
    },
    mounted: function() {

        // Animate names in
        const $instance = $(`#${this.id}`);
        const instance = this;
        const duration = !this.contentInitiated
            ? CONFIG.projects.detailContentAnimationSpeed
            : 0;
        new Animation($instance, "Fade Top", 1, duration, 0, function() {
            if (instance.primary) {
                instance.$emit("content-initiated", "Types");
            }
        });

    },
    emits: [ ...projectModel.emits ]
};
</script>